import React, {  useRef } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import {  EMPTY_OBJECT } from '../../constants/globalConstants'
require('./FileUpload.scss')

function FileUpload(props) {
    const { name, accept, onChange, id, idProof, required, disabled, hideLabel, className } = props
    const hiddenFileInput = useRef(null)
    

    const handleClick = () => {
        hiddenFileInput.current.click()

      }
    // const renderErrors = () => {
    //     const { errors, name } = props
    //     if (!errors || !errors[name]) return false


    //     return errors[name].map((e, i) => <div key={i} className="error" style={{ color: 'red' }}>{e}</div>)
    // }
        return (
            <div className={`${className ? className : ''} col-sm-6`}>
                <div className="mb-3 position-relative">
                {!hideLabel ? <label className="form-label">Drivers License Proof  ({name.charAt(0).toUpperCase() + name.slice(1)}) 
                    </label> : null }
                    <div className='input-group'>
                    <button type='button' onClick={handleClick} className='btn btn-primary'>Upload</button>
                        <input type="text" onClick={handleClick} className='form-control'  value={id == 'front' ? idProof?.front?.name ? idProof?.front?.name : 'Select file' : idProof?.back?.name ? idProof?.back?.name : 'Select file'}  readOnly />
                    </div>
                    <input                             
                        aria-describedby="emailHelp"
                        type="file"
                        ref={hiddenFileInput}
                        hidden
                        accept={accept}
                        onChange={onChange}
                        name={name}
                        className='form-control'
                        id={id}
                        disabled={disabled}
                        required={required}
                    />
                    <span 
                        className={'position-absolute end-0 top-100'}
                        htmlFor={id}
                    ></span>
                </div>
                {/* {renderErrors()} */}
            </div>
        )
    }

FileUpload.propTypes = {
    name: PropTypes.string,
    onChange: PropTypes.func,
    errors: PropTypes.objectOf(
        PropTypes.arrayOf(PropTypes.string)
    ),
    id: PropTypes.string,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    accept: PropTypes.string,
    idProof:PropTypes.object,
    hideLabel:PropTypes.bool,
    className: PropTypes.string,
}
FileUpload.defaulProps = {
	name: undefined,
    onChange: noop,
    errors: EMPTY_OBJECT,
    id: undefined,
    required: false,
    disabled: false,
    accept: undefined,
    idProof:EMPTY_OBJECT,
    hideLabel:false,
    className: ''
}

const mapStateToProps = () => {
    return {} // Return props object
}

export default connect(mapStateToProps)(FileUpload)
